import { render, staticRenderFns } from "./canals.vue?vue&type=template&id=7d44cebc&"
import script from "./canals.vue?vue&type=script&lang=js&"
export * from "./canals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports